import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './Support.css';

const WEB3FORMS_ACCESS_KEY = 'bd2af2ed-c850-41df-83fb-543406e3cf23';

function Support() {
  const [name, setName] = useState('');
  const [mobile, setMobile] = useState('');
  const [reason, setReason] = useState('');
  const [message, setMessage] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [toast, setToast] = useState(null); // { type: 'success' | 'error', message: string }

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (isSubmitting) return;
    setIsSubmitting(true);
    setToast(null);

    try {
      const formData = new FormData();
      formData.append('access_key', WEB3FORMS_ACCESS_KEY);
      formData.append('name', name);
      formData.append('registered_mobile_number', mobile);
      formData.append('reason', reason);
      formData.append('message', message);

      const response = await fetch('https://api.web3forms.com/submit', {
        method: 'POST',
        body: formData,
      });

      const data = await response.json();

      if (data.success) {
        setToast({ type: 'success', message: 'Request submitted successfully. We\'ll get back to you soon.' });
        setName('');
        setMobile('');
        setReason('');
        setMessage('');
      } else {
        setToast({ type: 'error', message: data.message || 'Something went wrong. Please try again.' });
      }
    } catch (err) {
      setToast({ type: 'error', message: 'Failed to send. Please check your connection and try again.' });
    } finally {
      setIsSubmitting(false);
    }
  };

  useEffect(() => {
    if (!toast) return;
    const id = setTimeout(() => setToast(null), 5000);
    return () => clearTimeout(id);
  }, [toast]);

  return (
    <div className="support-page">
      {toast && (
        <div className={`toast toast-${toast.type}`}>
          {toast.message}
        </div>
      )}
      <div className="support-container">
        <h1 className="page-title">Support</h1>
        <p className="page-subtitle">
          Send us your issue or question. We'll get back to you soon.
        </p>

        <div className="support-form-container">
          <form onSubmit={handleSubmit} className="support-form">
            <input type="hidden" name="access_key" value={WEB3FORMS_ACCESS_KEY} />
            <div className="form-group">
              <label htmlFor="name">Name</label>
              <input
                type="text"
                id="name"
                name="name"
                value={name}
                onChange={(e) => setName(e.target.value)}
                placeholder="Your name"
                className="form-input"
                required
              />
            </div>

            <div className="form-group">
              <label htmlFor="mobile">Registered mobile number</label>
              <input
                type="tel"
                id="mobile"
                name="registered_mobile_number"
                value={mobile}
                onChange={(e) => setMobile(e.target.value)}
                placeholder="e.g. 9876543210"
                className="form-input"
                required
              />
            </div>

            <div className="form-group">
              <label htmlFor="reason">Reason</label>
              <select
                id="reason"
                name="reason"
                value={reason}
                onChange={(e) => setReason(e.target.value)}
                className="form-input"
                required
              >
                <option value="" disabled>Select a reason</option>
                <option value="account issue">Account issue</option>
                <option value="payment issue">Payment issue</option>
                <option value="cancel subscription">Cancel subscription</option>
                <option value="other">Other</option>
              </select>
            </div>

            <div className="form-group">
              <label htmlFor="message">Message (optional)</label>
              <textarea
                id="message"
                name="message"
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                placeholder="Add any additional details (optional)..."
                className="form-textarea"
                rows="6"
              />
            </div>

            <div className="form-actions">
              <button type="submit" className="submit-button" disabled={isSubmitting}>
                {isSubmitting ? 'Sending...' : 'Send Support Request'}
              </button>
              <Link to="/" className="cancel-button">
                Cancel
              </Link>
            </div>

            <p className="form-footer">
              Your request will be sent to <strong>support@apnasoundbox.com</strong>.
            </p>
          </form>
        </div>
      </div>
    </div>
  );
}

export default Support;
